<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
          :active.sync="isLoading"
          loader="spinner"
          color="#36304a"
          :width="70"
      ></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-row>
        <b-navbar-nav>
          <b-button @click="previousSalesView" size="xxl" variant="light">
            <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
          </b-button>
        </b-navbar-nav>

        <b-col md="8">
            <h3 class="page-title mb-2"> <b> Assignment Pendency </b></h3>
            <h5 class="page-title mb-1"> Track and view the details of your package </h5>
        </b-col>
      </b-row>

      <div class="mt-3">
        <!-- Search Form Input Start-->
        <b-row>
          <b-col md="10" class="my-1">
            <b-form-group>
              <b-input-group>
                <b-form-input
                  :formatter="capitalizeAll"
                  @input="debounceSearch"
                  v-model="filter"
                  placeholder="Type to Search Assignment"
                  ref="search"
                />
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="2"><h5><small v-if="isLoading == false">{{ totalRows }} Entries</small></h5></b-col>
        </b-row>
        
        <div>
          
          <b-table 
            show-empty
            stacked="md"
            responsive
            :fields="columnMain" 
            :items="combinedItems"
            :tbody-tr-class="customRowClass"
            class="table-background position-relative"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            @filtered="onFiltered"
          >

            <!-- <template slot="A" slot-scope="row0">
              <span>
                {{ row0.index < 1 ? "Branch" : row0.item.A }}
              </span>
            </template> -->

          </b-table>
      
        </div>

        <b-row>
          <b-col md="12" class="my-1">
            <b-pagination
            limit="5"
            :total-rows="items.length"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0 pull-right"
            />
          </b-col>
        </b-row>
      </div>

    </b-card>
  </div>
</template>
  
<script>
  import axios from "axios";
  import moment from "moment";
  import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
  
import CustomLoader from "../common/customLoader.vue";
  import "vue-loading-overlay/dist/vue-loading.css";
  import { ModelListSelect } from "vue-search-select";
  import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
  import { DateFormat, selectDateFormat } from "../../helper/filters";
  import {
    lastVisitPage,
    globalPermissionStatus,
    GlobalContainerValid,
    GlobalGetLocation,
  } from "../../helper/collection";
  import CommonService from "../../services/CommonService.js";
  import DateRangePicker from "vue2-daterange-picker";
  
  export default {
    beforeMount() {
      if (
        this.$sessionsStorage.get("loginId") != undefined &&
        this.$sessionsStorage.get("loginId") != ""
      ) {
        this.$store.dispatch("setCurrentRoute", "/EmailSection");
        if (globalPermissionStatus("Dashboard_Access")) {
          // this.getAllEmailDataMasterList('Normal'); put your listing function here
        } else {
          this.$router.push({
            path: "/dashboard",
          });
        }
      } else {
        this.$router.push({
          path: "/Login/",
        });
      }
    },
    
    data() {
      return {
        isLoading: false,
        totalRows: "",
        filter: null,
        sortDesc: false,
        currentPage: 1,
        perPage: 10,
        fixedRowsData: [],

        columnMain: [
          {
            key: "A",
            label: "A",
          },
          {
            key: "B",
            label: "B",
          },
          {
            key: "C",
            label: "C",
          },
          {
            key: "D",
            label: "D",
          },
          {
            key: "E",
            label: "E",
          },
          {
            key: "F",
            label: "F",
          },
          {
            key: "G",
            label: "G",
          },
          {
            key: "H",
            label: "H",
          },
          {
            key: "I",
            label: "I",
          },
          {
            key: "J",
            label: "J",
          },
          {
            key: "K",
            label: "K",
          },
          {
            key: "L",
            label: "L",
          },
          {
            key: "M",
            label: "M",
          },
          {
            key: "N",
            label: "N",
          },
          {
            key: "O",
            label: "O",
          }
        ],

        fixedRows: [
          { A: 'Branch', B: 'Booking No.', C: 'Assignment No. with Date', D: 'Client Name', E: 'Shipping Line Name', F: 'POR', G: 'POL', H: 'POD', I: 'FPOD', J: 'VGM Date/Cutoff',  K: 'SI Date/Cutoff', L: 'TR Date/CutOFF', M: 'Sline Payment Date', N: 'SOB',  O: 'ETA Destination(Actual, Estimated)'},
        ],
                
        items: [
          { A: '1', B: 'data', C: 'data', D: 'data', E: 'data', F: 'data', G: 'data', H: 'data', I: 'data', J: 'data', K: 'data', L: 'data', M: 'data', N: 'data', O: 'data'},
          { A: '2', B: 'data', C: 'data', D: 'data', E: 'data', F: 'data', G: 'data', H: 'data', I: 'data', J: 'data', K: 'data', L: 'data', M: 'data', N: 'data', O: 'data'},
          { A: '3', B: 'data', C: 'data', D: 'data', E: 'data', F: 'data', G: 'data', H: 'data', I: 'data', J: 'data', K: 'data', L: 'data', M: 'data', N: 'data', O: 'data'},
          { A: '4', B: 'data', C: 'data', D: 'data', E: 'data', F: 'data', G: 'data', H: 'data', I: 'data', J: 'data', K: 'data', L: 'data', M: 'data', N: 'data', O: 'data'},
          { A: '5', B: 'data', C: 'data', D: 'data', E: 'data', F: 'data', G: 'data', H: 'data', I: 'data', J: 'data', K: 'data', L: 'data', M: 'data', N: 'data', O: 'data'},
          { A: '6', B: 'data', C: 'data', D: 'data', E: 'data', F: 'data', G: 'data', H: 'data', I: 'data', J: 'data', K: 'data', L: 'data', M: 'data', N: 'data', O: 'data'},
          { A: '7', B: 'data', C: 'data', D: 'data', E: 'data', F: 'data', G: 'data', H: 'data', I: 'data', J: 'data', K: 'data', L: 'data', M: 'data', N: 'data', O: 'data'},
          { A: '8', B: 'data', C: 'data', D: 'data', E: 'data', F: 'data', G: 'data', H: 'data', I: 'data', J: 'data', K: 'data', L: 'data', M: 'data', N: 'data', O: 'data'},
          { A: '9', B: 'data', C: 'data', D: 'data', E: 'data', F: 'data', G: 'data', H: 'data', I: 'data', J: 'data', K: 'data', L: 'data', M: 'data', N: 'data', O: 'data'},
          { A: '10', B: 'data', C: 'data', D: 'data', E: 'data', F: 'data', G: 'data', H: 'data', I: 'data', J: 'data', K: 'data', L: 'data', M: 'data', N: 'data', O: 'data'},
          { A: '11', B: 'data', C: 'data', D: 'data', E: 'data', F: 'data', G: 'data', H: 'data', I: 'data', J: 'data', K: 'data', L: 'data', M: 'data', N: 'data', O: 'data'},
          { A: '12', B: 'data', C: 'data', D: 'data', E: 'data', F: 'data', G: 'data', H: 'data', I: 'data', J: 'data', K: 'data', L: 'data', M: 'data', N: 'data', O: 'data'},
          { A: '13', B: 'data', C: 'data', D: 'data', E: 'data', F: 'data', G: 'data', H: 'data', I: 'data', J: 'data', K: 'data', L: 'data', M: 'data', N: 'data', O: 'data'},
        ]      
      };
    },
  
    mounted() {},
    filters: {},
    beforeDestroy() {},
    destroyed() {},
  components: {
      //  CustomLoader, //himanshu check if required or not 
    },
    
    created() {
      // Initialize fixedRowsData with a copy of fixedRows
      this.fixedRowsData = this.fixedRows.slice();
    },

    computed: {

      combinedItems() {
        const items = this.items.slice(); 
        const fixedRows = this.fixedRowsData.slice(); 

        for (let i = 0; i < items.length; i += 10) {
          // Insert a copy of fixedRowsData every 10 rows
          items.splice(i, 0, ...fixedRows);
        }

        return items;
      },
      
    },

    watch: {},

    methods: {
      isFixedRow(item) {
        return this.fixedRows.includes(item);
      },

      customRowClass(item) {
          if (this.isFixedRow(item)) {
          return 'customRowClass';
        }
      },

      filterClear() {
        this.filter = "";
        this.getAllEmailDataMasterList('Normal');
      },
    
      onFiltered(filteredItems) {
        // this.totalRows = filteredItems.length;
        // this.currentPage = 1;

        const fixedRows = this.combinedItems.slice(0, 10); // Assuming 10 rows are fixed
        const filteredData = filteredItems.filter((item, index) => index >= 10);

        // Concatenate the fixed/static rows and the filtered data
        this.combinedItems = fixedRows.concat(filteredData);

        this.totalRows = this.combinedItems.length;
        this.currentPage = 1;
      },

      previousSalesView() {
        window.history.go(-1);
      },

      debounceSearch(event) {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
          this.getAssignmentPendencyList();
        }, 1000);
      },
    },
  };
</script>


<style>

  .table-background thead{
    background-color: white;
    border-color: lightgrey;
    border-bottom-style: none;
    border-style: solid;
    border-width: 2px;
    height: 40px;
    font-size: 15px;
  }

  /* CSS for the text color of th elements in the black */
  .table-background th{
    color: lightslategray;
    border-color: lightgrey;
    border-width: 2px;
    border-style: solid;
    text-align: center;
    height: 40px;
    font-size: 15px;
  }

  .table-background tr td{
    color: black;
    border-color: black;
    border-width: 1px;
    border-style: solid;
    text-align: center;
    height: 45px;
    font-size: 15px;
  }

  .customRowClass {
    background-color: #A9E4CE;
    color: black;
    border-color: black;
    border-width: 1px;
    border-style: solid;
    text-align: center;
    font-weight: bold;
    font-size: 15px;
  }

</style>
  


// WEBPACK FOOTER //
// assignmentPendency.vue?28e80ce2